import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const SaveIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.78125 16.5625V12.3438C5.78125 11.826 6.20098 11.4062 6.71875 11.4062H13.2812C13.799 11.4062 14.2188 11.826 14.2188 12.3438V17.0312M14.2188 3.4375V5.3125C14.2187 5.83027 13.799 6.25 13.2812 6.25L6.71875 6.25C6.20098 6.25 5.78125 5.83027 5.78125 5.3125L5.78125 2.5M17.0293 5.77927L14.2207 2.97073C13.9193 2.66933 13.5105 2.5 13.0843 2.5H4.10714C3.21953 2.5 2.5 3.21953 2.5 4.10714V15.8929C2.5 16.7805 3.21953 17.5 4.10714 17.5H15.8929C16.7805 17.5 17.5 16.7805 17.5 15.8929V6.91569C17.5 6.48945 17.3307 6.08067 17.0293 5.77927Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </BaseIcon>
  );
};

SaveIcon.displayName = 'SaveIcon';
